import Vue from "vue";
import Vuex from "vuex";
import menuConfig from "./menuConfig";
import listApply from "./modules/listApply";

Vue.use(Vuex);

const { Store } = Vuex;

export default new Store({
    modules: {
        // 菜单配置
        menuConfig,
        // 科研课题
        listApply
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js